<template>
    <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(slide,key) in swiperSlides" :key="key">
            <div class="swiper-center">
                <div class="ban-pro">
                    <h1>{{slide.title}}</h1>
                    <p>{{slide.content}}</p>
                    <i v-for="icon in slide.icons" :style="{'background':'url('+icon.iconUrl+')'+' no-repeat'+' left'}" :_src="icon.iconUrl1"></i>
                </div>
                <img :src="slide.url" :_src="slide.url1" alt="" ref="swiperIMG" >
            </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<script>
    import {swiper, swiperSlide} from 'vue-awesome-swiper';

    export default {
        name: 'carousel',
        props: ['swiperSlides'],
        data() {
            return {
                swiperOption: {
                    notNextTick: true,
                    // swiper configs 所有的配置同swiper官方api配置
                    autoplay: true,
                    speed: 2000,
                    loop: 'true',
                    direction: 'horizontal',
                    // grabCursor : true,
                    // autoHeight: true,
                    paginationClickable: true,
                    setWrapperSize: true,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: 'true'
                    }
                }
            }
        },
        components: {
            swiper,
            swiperSlide
        },
        created(){
            // this.addClassName()
        },
        mounted(){
            this.addClassName()
        },
        methods: {
            stopPlay() {
                this.mySwiper.stopAutoplay();
            },
            play() {
                this.mySwiper.startAutoplay();
            },
            addClassName() {
                var routeId = this.$route.path
                // console.log(routeId);
                this.$refs.swiperIMG.forEach((item)=>{
                    if(routeId==='/product'){
                      return  item.setAttribute('className','.product-swiper')
                        console.log(item);
                    }else{
                        item.setAttribute('className','.home-swiper')
                    }

                })

            }
        }
    }
</script>
<style >

    img {
        /*display: block;*/
        /*width: 100%;*/
        /*height: 840px;*/
    }
    .product-swiper{
        height: 520px;
    }
    .swiper-center{
        width: 100%;
    }

</style>




// WEBPACK FOOTER //
// src/common/swiper.vue